// Archived master data (archived_at set): hidden for new trials, still shown on existing ones.
import { CO_LABEL } from './contractLabel';

export const isArchived = (row) => Boolean(row?.archived_at);

/** The rows to show in a master data table: archived ones only with "Show archived". */
export const visibleRows = (rows, showArchived) => (showArchived ? rows : rows.filter((r) => !isArchived(r)));

/**
 * A dropdown's options for a trial: the active rows, plus the trial's current one even when it is
 * archived (marked as such), so an existing trial keeps showing its value.
 */
export function optionsWithCurrent(rows, currentId) {
  return rows.filter((r) => !isArchived(r) || String(r.id) === String(currentId ?? ''));
}

// The master data a trial uses (as the API's trial sends it), and how each is named
const TRIAL_MASTER_DATA = [
  { label: 'Customer', row: (t) => t.customer, value: (r) => r.name },
  { label: CO_LABEL, row: (t) => t.project?.contract, value: (r) => r.co },
  { label: 'Protocol No', row: (t) => t.project, value: (r) => r.protocolno },
  { label: 'Host', row: (t) => t.host, value: (r) => r.name },
  { label: 'Country', row: (t) => t.country, value: (r) => r.name },
  { label: 'Crop', row: (t) => t.crop, value: (r) => r.name },
  { label: 'Study Type', row: (t) => t.study_type, value: (r) => r.name },
  { label: 'Trial Type', row: (t) => t.trial_type, value: (r) => r.name },
  { label: 'Study Director', row: (t) => t.study_director, value: (r) => r.name || r.initials },
  { label: 'Field Technician', row: (t) => t.field_technician, value: (r) => r.name || r.initials },
  { label: 'Principal Investigator', row: (t) => t.principal_investigator, value: (r) => r.name || r.initials },
];

/** The archived master data a trial uses: [{ label: 'CO', value: '2' }, ...]. */
export function archivedDataOf(trial) {
  if (!trial) return [];
  return TRIAL_MASTER_DATA.flatMap(({ label, row, value }) => {
    const r = row(trial);
    return isArchived(r) ? [{ label, value: String(value(r) ?? '') }] : [];
  });
}

/** "Name (archived)" for an archived row's option. */
export const optionLabel = (row, label) => (isArchived(row) ? `${label} (archived)` : label);
